import { render, staticRenderFns } from "./fleeingCount.vue?vue&type=template&id=1fb0aed2&scoped=true&"
import script from "./fleeingCount.vue?vue&type=script&lang=js&"
export * from "./fleeingCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb0aed2",
  null
  
)

export default component.exports